document.addEventListener('DOMContentLoaded', () => {
    const $navbar = document.getElementById('navbar');

    if ($navbar) {
        document.addEventListener('scroll', () => {
            if (window.scrollY === 0) {
                $navbar.classList.remove('is-stuck');
            }
            else {
                $navbar.classList.add('is-stuck');
            }
        });
    }
});